<div class="ipm-button"  
    [class.center]="buttonAlignment === 'center'" 
    [class.right]="buttonAlignment === 'right'"
    [class.left]="buttonAlignment === 'left'"
    role="button" 
    *ngIf="borderGradient"
    (click)="triggerClickEvent()">
    <div class="ipm-btn-section">
        {{buttonName}}
    </div>
</div>
<button class="ipm-button-bg"
    [class.btn-bg]="isShowBg"
    [class.center]="buttonAlignment === 'center'" 
    [class.right]="buttonAlignment === 'right'"
    [class.left]="buttonAlignment === 'left'"
    role="button" 
    *ngIf="!borderGradient"
    (click)="triggerClickEvent()">
        {{buttonName}}
</button>